import FinishProposalUserAddress from './FinishProposalUserAddress';

export default FinishProposalUserAddress;
